import { httpsCallable } from "firebase/functions";
import { functions } from "../config/firebase";
import { requireGuestSharedAccessActor } from "../auth/guestSharedAccessActor";
import {
  type MutationReceipt,
  type ShoppingChange,
} from "./sharedListMutations";

/** Immediate writes and restored work use exactly the same authenticated path. */
export async function executeSharedListMutation(
  listId: string,
  change: ShoppingChange,
): Promise<MutationReceipt> {
  await requireGuestSharedAccessActor();
  if (change.kind === "add") {
    const callable = httpsCallable<
      {
        listId: string;
        itemName: string;
        operationId: string;
      },
      MutationReceipt
    >(functions, "addSharedGroceryListItem");
    return (
      await callable({
        listId,
        itemName: change.name,
        operationId: change.operationId,
      })
    ).data;
  }
  if (change.kind === "remove") {
    await httpsCallable(
      functions,
      "removeSharedGroceryListItem",
    )({ listId, itemId: change.itemId });
    return {};
  }
  const data =
    change.kind === "rename"
      ? { name: change.name, operationId: change.operationId }
      : {
          isChecked: change.isChecked,
          ...(change.checkedAtMs !== undefined
            ? { checkedAtMs: change.checkedAtMs }
            : {}),
        };
  const result = await httpsCallable<unknown, MutationReceipt>(
    functions,
    "updateSharedGroceryListItem",
  )({ listId, itemId: change.itemId, ...data });
  return result.data ?? {};
}
